import { useEffect } from 'react';
import LeftSidePopupLayout from './modal-layout';
import XCloseIcon from '../icons/x-close';
import Style from './style.module.css'
import { useApiCall } from '../custom-hooks/api-call';
import { useFormik } from 'formik';
import * as yup from "yup";

const MileageModal = ({ onSubmit = () => { }, onClose = () => { }, onError = () => { }, carData, cars = [] }) => {
  const apiCall = useApiCall();

  useEffect(() => {
    if (carData?.id) {
      formik.setFieldValue("car", carData?.car_id || "")
      formik.setFieldValue("record_month", carData?.record_month || "")
      formik.setFieldValue("km", carData?.km_value || "")
      formik.setFieldValue("record_date", carData?.record_date || "")
    }
  }, [])

  const validationSchema = yup.object({
    car : yup
      .string('This Field is Required')
      .required('This Field is Required'),
    record_month: yup
      .string('This Field is Required')
      .required('This Field is Required'),
    km: yup
      .string('This Field is Required')
      .required('This Field is Required'),
    record_date: yup
      .string('This Field is Required')
      .required('This Field is Required')

  });

  const formik = useFormik({
    initialValues: {
      car:'',
      record_month: '',
      km: '',
      record_date: '',
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {

      let extraData = {};

      if (carData?.id) {
        extraData = {
          "id": carData?.id
        }
      }

      let data = {
        ...extraData,
        "car_id": values?.car,
        "record_month": values?.record_month,
        "km_value": values?.km,
        "record_date": values?.record_date
      }

      try {
        let apiRes = await apiCall({ method: "post", url: "add-update-car-mileage", data: data })
        formik.resetForm();
        onSubmit(apiRes?.message || `Request Submitted`);
      } catch (error) {
        console.log("Error", error)
        onError(error?.response.data?.respMsg || error?.response.data?.responseMessage || error?.response.data?.message || "Some Thing Went Wrong")
      }
    },
  });

  return (
    <form onSubmit={formik.handleSubmit}>
      <LeftSidePopupLayout popupStatus={true} className={`${Style.addMeModal} ${Style.leaveModal} !gap-0`}>
        <div className={`${Style["modal_header"]} ${Style.addMeModal_head}`}>
          <h4>{(carData?.id) ? "Update" : "Add"} Mileage</h4>
          <div onClick={onClose} className={`${Style["close_btn"]} cursor-pointer`}><XCloseIcon /></div>
        </div>

        <div className={`${Style.addMeModal_body}`}>
          <div className={`${Style.dcmb__card}`}>
            <div className={`${Style.dcmb__cardBody}`}>
              <div className={`${Style.dcmb__cardBody_formArea} pt-3`}>
                {/* Vendors */}

                <div className={Style["dcmb__cardBody_formArea_feild"]}>
                  <label htmlFor="">Car</label>
                  <select name='car' value={formik.values.car} onChange={formik.handleChange}>
                    <option value="" disabled selected>-- Select Car --</option>
                    {cars?.map((eachCar, index) => (
                      <option value={eachCar?.id} key={index}>{eachCar?.name}</option>
                    ))}
                  </select>
                  {
                    (formik.touched.car && Boolean(formik.errors.car)) ?
                      <span style={{ color: "red" }} className='ps-1'>{formik.touched.car && formik.errors.car}</span>
                      :
                      null
                  }
                </div>

                {/* Invoice Month */}

                <div className={`${Style["dcmb__cardBody_formArea_feild"]}`}>
                  <div className={`${Style["dcmb__cardBody_formArea_feild"]}`}>
                    <label htmlFor="">Record Month</label>
                    <input
                      type="month"
                      name='record_month'
                      min={1}
                      value={formik.values.record_month}
                      onChange={formik.handleChange}
                      placeholder='Invoice month'
                    />
                    {
                      (formik.touched.record_month && Boolean(formik.errors.record_month)) ?
                        <span style={{ color: "red" }} className='ps-1'>{formik.touched.record_month && formik.errors.record_month}</span>
                        :
                        null
                    }
                  </div>
                </div>

                {/* Invoice Amount */}

                <div className={`${Style["dcmb__cardBody_formArea_feild"]}`}>
                  <div className={`${Style["dcmb__cardBody_formArea_feild"]}`}>
                    <label htmlFor="">Km</label>
                    <input
                      type="text"
                      name='km'
                      value={formik.values.km}
                      onChange={formik.handleChange}
                      placeholder='Km'
                    />
                    {
                      (formik.touched.km && Boolean(formik.errors.km)) ?
                        <span style={{ color: "red" }} className='ps-1'>{formik.touched.km && formik.errors.km}</span>
                        :
                        null
                    }
                  </div>
                </div>

                <div className={`${Style["dcmb__cardBody_formArea_feild"]}`}>
                  <div className={`${Style["dcmb__cardBody_formArea_feild"]}`}>
                    <label htmlFor="">Record Date</label>
                    <input
                      type="date"
                      name='record_date'
                      value={formik.values.record_date}
                      onChange={formik.handleChange}
                      placeholder='Invoice Date'
                    />
                    {
                      (formik.touched.record_date && Boolean(formik.errors.record_date)) ?
                        <span style={{ color: "red" }} className='ps-1'>{formik.touched.record_date && formik.errors.record_date}</span>
                        :
                        null
                    }
                  </div>
                </div>
               
              </div>
            </div>
          </div>
        </div>

        <div className={`${Style.dcmb__cardFoot}`}>
          <button type='reset' className={`${Style.dcmb__cancel}`} onClick={onClose}>Discard</button>
          <button type='submit' className={`${Style.dcmb__submit}`}>Apply</button>
        </div>
      </LeftSidePopupLayout>
    </form>
  )
}

export default MileageModal